var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 22.97,
    fill: "#FFC106"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.4c0 1.52 0 2 0 2m-9.8 0.63c0.76 1.32 1 1.73 1 1.73m-8.17 5.44c1.32 0.76 1.73 1 1.73 1m-4.36 8.8c1.53 0 2 0 2 0m0.63 9.8c1.32-0.76 1.73-1 1.73-1m5.44 8.17c0.76-1.32 1-1.73 1-1.73m8.8 4.36c0-1.53 0-2 0-2m9.8-0.63c-0.76-1.32-1-1.73-1-1.73m8.17-5.44c-1.32-0.76-1.73-1-1.73-1m4.36-8.8c-1.53 0-2 0-2 0m-0.63-9.8c-1.32 0.76-1.73 1-1.73 1m-5.44-8.17c-0.76 1.32-1 1.73-1 1.73",
    fill: "none",
    stroke: "#FFC106",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 22.9256
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01D);
export default __webpack_public_path__ + "static/media/01d.23409ed6f1a17c0424cc0ac6dccd11c0.svg";
export { ForwardRef as ReactComponent };